import type {
  FeatureAccessSnapshot,
  FeatureAllowRole,
  FeatureKey,
  FeaturePolicy,
  FeatureRule,
} from '../types';

export const FEATURE_DISABLED = 'FEATURE_DISABLED';

export const FEATURE_LABELS: Record<FeatureKey, string> = {
  events: 'Events',
  quiz: 'Quiz',
  leaderboard: 'Leaderboard',
  members: 'Members',
  admin: 'Admin',
};

export const FEATURE_DESCRIPTIONS: Record<FeatureKey, string> = {
  events: 'Community events listing and RSVP surfaces',
  quiz: 'Campaign quiz play and session attempts',
  leaderboard: 'Campaign cumulative leaderboard',
  members: 'Admin people management at /members',
  admin: 'Content management at /admin (events, quizzes, banner)',
};

export const FEATURE_ALLOW_ROLES: FeatureAllowRole[] = ['admin', 'member'];

export function canAccessFeatureFromSnapshot(
  snapshot: FeatureAccessSnapshot | null | undefined,
  feature: FeatureKey,
): boolean {
  return snapshot?.[feature] ?? true;
}

export function defaultFeatureAccessSnapshot(): FeatureAccessSnapshot {
  return {
    events: true,
    quiz: true,
    leaderboard: true,
    members: true,
    admin: true,
  };
}

export function featureUnavailableMessage(feature: FeatureKey): string {
  return `${FEATURE_LABELS[feature]} is not available right now.`;
}

export function featureAccessSummary(rule: FeatureRule): string {
  if (rule.enabled) return 'Enabled for everyone signed in';

  const parts: string[] = ['Disabled globally'];
  if (rule.allowedRoles.length > 0) {
    parts.push(`roles: ${rule.allowedRoles.join(', ')}`);
  }
  if (rule.allowedEmails.length > 0) {
    parts.push(
      `${rule.allowedEmails.length} allowlisted email${rule.allowedEmails.length === 1 ? '' : 's'}`,
    );
  }
  return parts.join(' · ');
}

export interface FeatureAccessDto {
  ok: boolean;
  policy: FeaturePolicy;
}
